export default __webpack_public_path__ + "static/media/logo-star.f90c1090.svg";